/**
 * Action that clears/reverses the search display
 * This action can be triggered with: window.addEventListener('arc:action:searchClear')
 */

export const runSearchClear = async (data = {}) => {
    try {
        const {
            message = 'Search cleared!',
            type = 'info',
            duration = 3000
        } = data;

        const searchFeatured = document.querySelector('.search-featured');
        const searchData = document.querySelector('.search-data');

        if (window.enableDebugMode) {
            console.log('Search Featured Element:', searchFeatured);
            console.log('Search Data Element:', searchData);
        }
        if (!searchFeatured || !searchData) {
            throw new Error('Search elements not found');
        }
        // Show the featured search section and hide the data section (reverse of runSearchAction)
        searchFeatured.style.setProperty('display', 'block', 'important');
        searchData.style.setProperty('display', 'none', 'important');

        return {
            success: true,
            message: 'Search cleared',
            data: { message, type, duration }
        };

    } catch (error) {
        console.error('Error clearing search:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

export default runSearchClear;
